import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

interface PlanillaPageLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
}

const PlanillaPageLayout = ({ children, title, description }: PlanillaPageLayoutProps) => (
  <div className="page-content">
    <Container fluid className="px-2 px-md-3">
      <BreadCrumb title={title} pageTitle="Recursos Humanos" />
      <Card>
        <CardBody>
          {description ? <p className="text-muted mb-4">{description}</p> : null}
          {children}
        </CardBody>
      </Card>
    </Container>
  </div>
);

export default PlanillaPageLayout;
